import type { IChecklistItem } from 'pages/Admin'

import {
  DEFAULT_CHECKLIST_REQUIRED_MESSAGE,
  DEFAULT_DOCUMENT_STATUS_BLOCK_MESSAGE,
  IConditionClearRules,
  normalizeConditionClearRules,
} from './types'

export const resolveDocumentStatus = (status?: string) => status || 'Not Reviewed'

export const getBlockingDocumentClearError = (
  docs: Array<{ status?: string }>,
  rulesInput: IConditionClearRules | Record<string, any>,
): string | null => {
  const rules = normalizeConditionClearRules(rulesInput)
  for (const doc of docs) {
    const status = resolveDocumentStatus(doc.status)
    const rule = rules.documentStatuses[status]
    if (!rule?.blockClear) continue
    const message = (rule.message || '').trim()
    return message || DEFAULT_DOCUMENT_STATUS_BLOCK_MESSAGE
  }
  return null
}

export const getChecklistClearError = (
  rulesInput: IConditionClearRules | Record<string, any>,
  checklistItems: IChecklistItem[] | undefined,
  answers: Record<string, any> | undefined,
  isVisible: (item: IChecklistItem) => boolean,
): string | null => {
  const rules = normalizeConditionClearRules(rulesInput)
  if (!rules.requireChecklistToClear || !checklistItems?.length) return null

  const incomplete = checklistItems.some((checkItem) => {
    if (!isVisible(checkItem)) return false
    const accepted = !!answers?.detail?.[checkItem.key]?.accept
    if (accepted) return false
    return (
      (checkItem.checkIneligible && answers?.[checkItem.key] !== checkItem.eligibleValue) ||
      answers?.[checkItem.key] === undefined
    )
  })
  if (!incomplete) return null
  return (rules.checklistRequiredMessage || '').trim() || DEFAULT_CHECKLIST_REQUIRED_MESSAGE
}
